import { render } from "./EditTINModalControl.vue?vue&type=template&id=a77f8074&scoped=true"
import script from "./EditTINModalControl.vue?vue&type=script&lang=js"
export * from "./EditTINModalControl.vue?vue&type=script&lang=js"

import "./EditTINModalControl.vue?vue&type=style&index=0&id=a77f8074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77f8074"]])

export default __exports__